import { render } from "./WordListRecognition.vue?vue&type=template&id=559eef2a&scoped=true"
import script from "./WordListRecognition.vue?vue&type=script&lang=js"
export * from "./WordListRecognition.vue?vue&type=script&lang=js"

import "./WordListRecognition.vue?vue&type=style&index=0&id=559eef2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-559eef2a"]])

export default __exports__